module.exports = __webpack_public_path__ + "img/t15.217f4bcf.jpg";